// src/push.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import AppSetup from "../core/AppSetup";

export function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  return navigator.serviceWorker.register('/sw.js');
}

export function attachSwMessageHandler() {
  if (!navigator.serviceWorker) return;
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'NAVIGATE' && event.data.url) {
      window.location.href = event.data.url;
    }
  });
}

export async function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getPermissionState() {
  // 'default' | 'granted' | 'denied'
  return Notification.permission;
}

// export async function requestPushPermission() {
//   const perm = await Notification.requestPermission();
//   return perm; // 'granted'/'denied'/'default'
// }

export async function getServiceWorkerRegistration() {
  // sicherstellen, dass ein SW da ist und ready ist
  const reg = await navigator.serviceWorker.ready;
  return reg;
}

export async function getExistingSubscription() {
  const reg = await getServiceWorkerRegistration();
  return reg.pushManager.getSubscription();
}

/* API calls */
const apiUrl = AppSetup.getUserApiUrl();
axios.defaults.baseURL = apiUrl;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json';
export const setToken = () => {
    const authToken = localStorage.getItem("AUTHTOKEN");
    // console.log("authtoken:", authToken);
    axios.defaults.headers.common.AuthToken =  authToken ? authToken : "";
}

export const getVapidPublicKey = createAsyncThunk(
    "get/vapidPublicKey",
    async (_: any, thunkAPI) => {
        try {
            return await axios.get("push/vapid");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
// export async function fetchVapidPublicKey() {
//   const r = await fetch('/api/push/vapid-public-key', { credentials: 'include' });
//   if (!r.ok) throw new Error(`Failed to fetch vapid key: ${r.status}`);
//   const j = await r.json();
//   if (!j.vapidPublicKey) throw new Error('Missing vapidPublicKey in response');
//   return j.vapidPublicKey;
// }

export const postSubscription = createAsyncThunk(
    "post/Subscription",
    async (param: any, thunkAPI) => {
        setToken();
        try { 
            return await axios.post("/push/subscribe", JSON.stringify(param));
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

// export async function sendSubscriptionToBackend(subscription: any) {
//   const r = await fetch('/api/push/subscribe', {
//     method: 'POST',
//     credentials: 'include', // wichtig bei Cookie-Session
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(subscription),
//   });
//   if (!r.ok) throw new Error(`subscribe backend failed: ${r.status}`);
//   return r.json().catch(() => ({}));
// }

export const postUnSubscription = createAsyncThunk(
  "post/UnSubscription",
  async (p: {sub:any, deleteAllForUser : boolean}, thunkAPI) => {
    setToken();
    const body = p.deleteAllForUser ? JSON.stringify({}) : JSON.stringify({ endpoint: p.sub?.endpoint });
    try { 
      return await axios.post("/push/unsubscribe", body);
    } catch (error) { 
      return thunkAPI.rejectWithValue({error});
    }
});

export async function unsubscribePush({ deleteAllForUser = false } = {}) {
  const reg = await getServiceWorkerRegistration();
  const sub = await reg.pushManager.getSubscription();

  // Backend opt-out + ggf. endpoint löschen
  // 1) Wenn du gezielt entfernen willst: endpoint senden
  // 2) Wenn du "alles löschen" willst: ohne endpoint senden (wie in deinem CGI-Beispiel)
  await fetch('/api/push/unsubscribe', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: deleteAllForUser
      ? JSON.stringify({})
      : JSON.stringify({ endpoint: sub?.endpoint }),
  });

  // Browser-seitig entfernen (empfohlen)
  if (sub) {
    await sub.unsubscribe();
  }
}
